module.exports = __webpack_public_path__ + "img/coca-cola-logo.b83835b1.jpg";